import DecorativeEllipse from "@/components/DecorativeEllipse";
import UrgencyBar from "./UrgencyBar";

const includedItems = [
  "5 módulos en video (6–12 min cada uno)",
  "5 guías descargables (PDF)",
  "5 Ebooks complementarios (PDF)",
  "Plantillas Excel / Sheets listas para usar",
  "Checklists de ejecución por módulo (acciones semanales)",
  "Bonus 1: Banco de mensajes copiar/pegar (DM / WhatsApp / email)",
  "Bonus 2: Lista de 30 ideas de oportunidades (empleo / freelance / colaboraciones)",
];

export default function PricingSection() {
  return (
    <section id="pricing" className="relative overflow-hidden" style={{ backgroundColor: "#0D0D0D" }}>
      {/* Decorative ellipses behind the card */}
      <DecorativeEllipse
        className="-top-24 -left-24"
        size={400}
        opacity={0.08}
        blur={120}
      />
      <DecorativeEllipse
        className="-bottom-32 -right-28"
        size={450}
        opacity={0.06}
        blur={140}
      />
      <DecorativeEllipse
        className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        size={500}
        opacity={0.04}
        blur={180}
      />

      {/* Gold gradient overlay across section */}
      <div className="absolute inset-0 bg-gradient-to-b from-gold/[0.02] via-transparent to-gold/[0.03] pointer-events-none" />

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="relative rounded-lg p-8 md:p-12 border border-gold/40 text-center overflow-hidden" style={{ backgroundColor: "#141414" }}>
          {/* Radial bg */}
          <div className="absolute inset-0 bg-gold-radial pointer-events-none" />

          {/* Decorative ellipse inside the card — top right corner */}
          <div className="absolute -top-16 -right-16 w-48 h-48 opacity-[0.07] pointer-events-none">
            <DecorativeEllipse className="top-0 right-0" size={192} opacity={1} blur={0} />
          </div>

          {/* Decorative ellipse inside the card — bottom left corner */}
          <div className="absolute -bottom-20 -left-20 w-52 h-52 opacity-[0.05] pointer-events-none">
            <DecorativeEllipse className="bottom-0 left-0" size={208} opacity={1} blur={0} />
          </div>

          {/* Gold gradient glow overlay inside card */}
          <div className="absolute inset-0 bg-gradient-to-br from-gold/[0.04] via-transparent to-gold/[0.02] pointer-events-none" />

          <div className="relative z-10">
            {/* Badge */}
            <span className="inline-block px-4 py-1.5 rounded-full border border-gold/40 text-gold text-xs md:text-sm font-sans font-medium tracking-wider uppercase mb-6">
              Precio de lanzamiento
            </span>

            <h2 className="font-serif text-2xl md:text-3xl text-cream mb-8">
              Todo lo que incluye
            </h2>

            {/* List */}
            <ul className="space-y-3 mb-10 text-left max-w-sm mx-auto">
              {includedItems.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="text-gold text-sm mt-0.5">&#10022;</span>
                  <span className="font-sans text-sm md:text-base text-cream/90">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            {/* Urgency Timer */}
            <div className="mb-8 -mx-2 md:-mx-4">
              <UrgencyBar variant="card" />
            </div>

            {/* Value strikethrough */}
            <p className="font-sans text-sm text-cream/40 mb-1">
              <span className="line-through">Valor real: USD $47</span>
            </p>

            {/* Price */}
            <div className="mb-2">
              <span className="font-serif text-5xl md:text-7xl lg:text-[72px] font-bold text-gold">
                $19
              </span>
              <span className="font-sans text-sm md:text-base text-cream/50 ml-2">
                USD
              </span>
            </div>
            <p className="font-sans text-xs md:text-sm text-cream/40 mb-8">
              Pago único. Acceso de por vida.
            </p>

            {/* CTA full width */}
            <a
              href="https://buy.stripe.com/dRm7sEbdm8bafGfeT0d3i03"
              className="block w-full py-4 md:py-5 rounded-md font-sans font-semibold text-base md:text-lg text-white transition-all duration-300 hover:scale-[1.01] hover:brightness-110"
              style={{ backgroundColor: "#2E7D32" }}
            >
              <span>Quiero acceso ahora</span>
              <i className="ri-arrow-right-line text-lg ml-2" />
            </a>

            {/* Garantía */}
            <div className="mt-6 flex items-center justify-center gap-2">
              <i className="ri-shield-check-line text-gold" />
              <span className="font-sans text-xs md:text-sm text-cream/50">
                Garantía de 7 días. Sin preguntas.
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Divider */}
      <div className="relative z-10 h-px bg-gold-gradient" />
    </section>
  );
}